import React from "react";
import Joyride from "react-joyride/lib/index.js";

export const JoyrideComponent = ({
    id = "",
    steps = [],
    run = false,
    stepIndex = 0,
    handleAppDemoCallback = () => {}
}) => {
  return (
    <Joyride
      steps={steps}
      run={run}
      stepIndex={stepIndex ? stepIndex : undefined}
      callback={(data) => handleAppDemoCallback(data, id)}

      continuous={true}
      // showProgress={true}
      // showSkipButton={true}
      // debug={true} // console joyride status
      scrollOffset={100}
      styles={{
        options: {
          backgroundColor: "#2193f3",
          textColor: "#fff",
          primaryColor: "#2193f3",
          arrowColor: "#2193f3",
          textAlign: "left",
          width: 270,
          zIndex: 10000,
        },
        tooltipContent: {
          textAlign: "left",
        },
        tooltip: {
          borderRadius: "20px",
          fontSize: "13px",
          zIndex: 10001,
        },
        buttonNext: {
          textTransform: "uppercase",
          fontWeight: "bold",
        },
      }}
    />
  );
};

export const styles = {
    paddingRight20: {
        paddingTop: '0px',
        paddingBottom: '0px',
        paddingLeft: '0px',
        paddingRight: '20px',
    },
    paddingRight10: {
        paddingTop: '0px',
        paddingBottom: '0px',
        paddingLeft: '0px',
        paddingRight: '10px',
    },
};

export const defaultStepSetting = {
    disableBeacon: true,
    placement: "bottom",
    disableScrolling: true,
    styles: {
      tooltipContent: {
        ...styles.paddingRight20,
      },
    },
}

export const stepsComponent = ({ inAppID = "", inAppContent = "" }) => {
  return ({
      target: inAppID,
      content: (
        <div>
          {inAppContent}
        </div>
      ),
      ...defaultStepSetting,
    });
}